import { Branches } from '../../../tabs/CampaignWorkflowTab/state/Branches/BranchesState';

export interface BranchesMapperModel {
  onsiteMessageSegments?: {
    segmentId: string;
    branchId: string;
    branchName: string;
  }[];
}

export class BranchesMapper {
  public static Map(response: BranchesMapperModel): Branches {
    if (response.onsiteMessageSegments?.length === 1) {
      return {};
    }

    const branches: Branches =
      response.onsiteMessageSegments?.reduce((prev, curr, i) => {
        if (!curr.branchName) {
          return prev;
        }

        return {
          ...prev,
          [curr.branchId]: {
            id: curr.branchId,
            name: curr.branchName,
            priority: i + 1,
          },
        };
      }, {}) ?? {};

    return branches;
  }
}
